<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>屈光参差变焦镜</el-breadcrumb-item>
      <el-breadcrumb-item>屈光参差变焦镜用户管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card" @tab-click="tabclick">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first" disabled="disabled">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.sn" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.account" @keyup.enter.native="clicksearch" placeholder="请输入账号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.phone" @keyup.enter.native="clicksearch" placeholder="请输入手机号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="注册时间(开始)" class="mr15"></el-date-picker>
            <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="注册时间(结束)" class="mr15"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Id" label="ID" min-width="5%"></el-table-column>
          <el-table-column prop="Jigouname" label="归属机构" min-width="10%"></el-table-column>
          <el-table-column prop="Sn" label="保修卡号" min-width="10%"></el-table-column>
          <el-table-column prop="Account" label="账号" min-width="10%"></el-table-column>
          <el-table-column prop="Name" label="姓名" min-width="10%"></el-table-column>
          <el-table-column prop="Age" label="年龄" min-width="10%"></el-table-column>
          <el-table-column prop="Sexs" label="性别" min-width="10%"></el-table-column>
          <el-table-column prop="Phone" label="电话号" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="注册时间" min-width="15%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_RefractiveDiscrepancyUser_Edit" @click="goCustomerChange(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="SubRule_RefractiveDiscrepancyUser_FuCha" @click="goViewVisionReview(scope.row)">视力复查管理</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加用户 start -->
      <el-tab-pane v-loading.fullscreen.lock="fullscreenloading" label="添加用户" name="second" v-if="SubRule_RefractiveDiscrepancyUser_Add">
        <el-form :model="addCustomer" ref="addCustomerRef" label-width="68px">
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input v-model="addCustomer.sn" placeholder="请输入保修卡号"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" class="addAdminForm">
            <el-input v-model="addCustomer.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="密码" class="addAdminForm">
            <el-input v-model="addCustomer.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="姓名" class="addAdminForm">
            <el-input v-model="addCustomer.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="性别" class="addAdminForm">
            <el-radio v-model="addCustomer.sex" label="1">男</el-radio>
            <el-radio v-model="addCustomer.sex" label="2">女</el-radio>
          </el-form-item>
          <el-form-item label="年龄" class="addAdminForm">
            <el-input v-model="addCustomer.age" placeholder="请输入年龄"></el-input>
          </el-form-item>

          <!-- 视光信息 start -->
          <div class="title">视光信息</div>
          <div class="optometry">
            <el-form-item label="屈光状态" class="select2">
              <el-select v-model="addCustomer.diopterstate" placeholder="请选择" style="width: 100%">
                <el-option label="请选择" value="0"></el-option>
                <el-option label="正视" value="6"></el-option>
                <el-option label="远视" value="2"></el-option>
                <el-option label="近视" value="1"></el-option>
                <el-option label="散光" value="7"></el-option>
                <el-option label="老花" value="3"></el-option>
                <el-option label="屈光参差" value="8"></el-option>
                <el-option label="远视性弱视" value="9"></el-option>
                <el-option label="散光性弱视" value="10"></el-option>
                <el-option label="近视性弱视" value="11"></el-option>
              </el-select>
            </el-form-item>
            <ul>
              <li>1. 0~+0.50D选择正视；</li>
              <li>2. 远视、远视+散光且矫正视力正常选择远视注册；</li>
              <li>3. 近视、近视+散光且矫正视力正常选择近视注册；</li>
              <li>4. 单纯散光选择散光注册；</li>
              <li>5. 40岁以上，近用需要下加光的选择老花注册；</li>
              <li>6. 球柱中和后，两眼度数相差1.00D以上选择屈光参差注册；</li>
              <li>公式：新球=1/2柱+球</li>
              <li>7. 矫正视力低于正常年龄下限的，请选择弱视注册。具体如下：</li>
              <li>（1）远视+散光引起的弱视：远视性弱视</li>
              <li>（2）近视+散光引起的弱视：近视性弱视</li>
              <li>（3）单纯散光引起的弱视：散光性弱视</li>
              <li>对应矫正视力下限如下：</li>
              <li>3岁：0.4；4岁：0.5；5岁：0.6,6岁：0.8；7岁以上：1.0及以上（年龄为周岁）</li>
            </ul>
          </div>
          <!-- 视光信息 end -->

          <!-- 屈光度 -->
          <el-table :data="diopterData" border stripe class="mt20">
            <el-table-column label="屈光度" align="center">
              <el-table-column label="OD(右眼)" align="center">
                <el-table-column prop="rightEye1" label="右眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.righteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye2" label="右眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.rightcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="rightEye3" label="右眼轴向(范围:0~+180)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.rightaxial" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column label="OS(左眼)" align="center">
                <el-table-column prop="leftEye1" label="左眼球镜(范围:-15.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.lefteyedegree" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye2" label="左眼柱镜(范围:-5.00D~+5.00D)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.leftcolumnmirror" class="input_num"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="leftEye3" label="左眼轴向(范围:0~+180)">
                  <template slot-scope="scope">
                    <el-input v-model="addCustomer.leftaxial" class="input_num"></el-input>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 裸眼和矫正视力 -->
          <el-table :data="nakedEye" border stripe class="mt20">
            <el-table-column label="5m裸眼视力(5分记录法)" align="center">
              <el-table-column prop="odRight" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.nakedbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column label="最佳矫正视力(5分记录法)" align="center">
              <el-table-column prop="odRight1" label="OD(右眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctrighteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="osLeft1" label="OS(左眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctlefteyedegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="ouDouble1" label="OU(双眼)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.correctbinoculusdegree" placeholder="请选择">
                    <el-option
                      v-for="item in eyedegreelist" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 瞳距和ADD -->
          <el-table :data="addData" border stripe class="mt20">
            <el-table-column label="瞳距和ADD" align="center">
              <el-table-column  prop="tongju" label="瞳距(单位:mm)">
                <template slot-scope="scope">
                  <el-input v-model="addCustomer.interpupillary"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="add" label="ADD(范围:0.00D~+5.00D)">
                <template slot-scope="scope">
                  <el-select v-model="addCustomer.addtype" placeholder="请选择" style="width: 100%">
                    <el-option label="0.00D" value="0"></el-option>
                    <el-option label="0.50D" value="1"></el-option>
                    <el-option label="0.75D" value="2"></el-option>
                    <el-option label="1.00D" value="3"></el-option>
                    <el-option label="1.25D" value="4"></el-option>
                    <el-option label="1.50D" value="5"></el-option>
                    <el-option label="1.75D" value="6"></el-option>
                    <el-option label="2.00D" value="7"></el-option>
                    <el-option label="2.25D" value="8"></el-option>
                    <el-option label="2.50D" value="9"></el-option>
                    <el-option label="2.75D" value="10"></el-option>
                    <el-option label="3.00D" value="11"></el-option>
                    <el-option label="3.25D" value="12"></el-option>
                    <el-option label="3.50D" value="13"></el-option>
                    <el-option label="3.75D" value="14"></el-option>
                    <el-option label="4.00D" value="15"></el-option>
                    <el-option label="4.25D" value="16"></el-option>
                    <el-option label="4.50D" value="17"></el-option>
                    <el-option label="4.75D" value="18"></el-option>
                    <el-option label="5.00D" value="19"></el-option>
                  </el-select>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>

          <!-- 眼轴，调节幅度 -->
          <el-table :data="tongJuData" border stripe class="mt20">
            <el-table-column  prop="tongju" label="右眼轴AL">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.alod"></el-input>
              </template>
            </el-table-column>
            <el-table-column  prop="tongju" label="左眼轴AL">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.alos"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="右眼调节幅度(范围:0.00D~+22.00D)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.ampod"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="左眼调节幅度(范围:0.00D~+22.00D)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.ampos"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="双眼调节幅度(范围:0.00D~+22.00D)">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.ampou"></el-input>
              </template>
            </el-table-column>
          </el-table>

          <!-- NRA，PRA -->
          <el-table :data="tongJuData" border stripe class="mt20">
            <el-table-column  prop="tongju" label="右眼NRA">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.nraod"></el-input>
              </template>
            </el-table-column>
            <el-table-column  prop="tongju" label="左眼NRA">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.nraos"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="双眼NRA">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.nraou"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="右眼PRA">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.praod"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="左眼PRA">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.praos"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="双眼PRA">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.praou"></el-input>
              </template>
            </el-table-column>
          </el-table>

          <!-- BCC，调节灵敏度 -->
          <el-table :data="tongJuData" border stripe class="mt20">
            <el-table-column  prop="tongju" label="BCC">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.bcc"></el-input>
              </template>
            </el-table-column>
            <el-table-column  prop="tongju" label="右眼调节灵敏度">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.flipperod"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="左眼调节灵敏度">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.flipperos"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="adjust" label="双眼调节灵敏度">
              <template slot-scope="scope">
                <el-input v-model="addCustomer.flipperou"></el-input>
              </template>
            </el-table-column>
          </el-table>

          <el-form-item class="mt20">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加用户 end -->

      <el-tab-pane label="修改用户" name="five" disabled="disabled">
        <RefractiveDiscrepancyUserEdit ref="SubVuefive" v-on:triggerFunc="BackToFirst"></RefractiveDiscrepancyUserEdit>
      </el-tab-pane>

      <el-tab-pane label="视力复查管理" name="seven" disabled="disabled">
        <RefractiveDiscrepancyUserFuCha ref="SubVueseven" v-on:triggerFunc="BackToFirst"></RefractiveDiscrepancyUserFuCha>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import RefractiveDiscrepancyUserEdit from '@/componentsSubVue/RefractiveDiscrepancyUserEdit.vue'
import RefractiveDiscrepancyUserFuCha from '@/componentsSubVue/RefractiveDiscrepancyUserFuCha.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    RefractiveDiscrepancyUserEdit,
    RefractiveDiscrepancyUserFuCha
  },
  name: 'MyRefractiveDiscrepancyUser',
  data () {
    return {
      loading: false,
      fullscreenloading: false,
      activeName: 'first',
      bomSnList: [],
      saleTypeList: [],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        jigouid: '-1',
        jigouname: '',
        sn: '',
        account: '',
        name: '',
        phone: '',
        begintime: '',
        endtime: ''
      },
      // 添加客户
      addCustomer: {
        sn: '',
        phone: '',
        password: '',
        name: '',
        age: '',
        sex: '1',
        diopterstate: '0',
        righteyedegree: '0.00',
        rightcolumnmirror: '0.00',
        rightaxial: '0',
        lefteyedegree: '0.00',
        leftcolumnmirror: '0.00',
        leftaxial: '0',
        nakedrighteyedegree: '0',
        nakedlefteyedegree: '0',
        nakedbinoculusdegree: '0',
        correctrighteyedegree: '0',
        correctlefteyedegree: '0',
        correctbinoculusdegree: '0',
        interpupillary: '',
        addtype: '0',
        alod: '0.00',
        alos: '0.00',
        ampod: '0.00',
        ampos: '0.00',
        ampou: '0.00',
        nraod: '0.00',
        nraos: '0.00',
        nraou: '0.00',
        praod: '0.00',
        praos: '0.00',
        praou: '0.00',
        bcc: '0.00',
        flipperod: '0.00',
        flipperos: '0.00',
        flipperou: '0.00'
      },
      //
      diopterData: [
        {
          rightEye1: '右眼',
          rightEye2: '右眼',
          rightEye3: '右眼',
          leftEye1: '右眼',
          leftEye2: '右眼',
          leftEye3: '右眼'
        }
      ],
      // ADD和调节幅度
      addData: [
        {
          add: 'add',
          adjust: '调节幅度'
        }
      ],
      // 裸眼和矫正视力
      nakedEye: [
        { odRight: '请选择', osLeft: '请选择', ouDouble: '请选择', odRight1: '请选择', osLeft1: '请选择', ouDouble1: '请选择' }
      ],
      tongJuData: [
        { tongju: '请输入', leftEye: '请选择', rightEye: '请选择' }
      ],
      eyedegreelist: [
        { value: '0', label: '请选择' },
        { value: '3.5', label: '3.5' },
        { value: '3.6', label: '3.6' },
        { value: '3.7', label: '3.7' },
        { value: '3.8', label: '3.8' },
        { value: '3.9', label: '3.9' },
        { value: '4.0', label: '4.0' },
        { value: '4.1', label: '4.1' },
        { value: '4.2', label: '4.2' },
        { value: '4.3', label: '4.3' },
        { value: '4.4', label: '4.4' },
        { value: '4.5', label: '4.5' },
        { value: '4.6', label: '4.6' },
        { value: '4.7', label: '4.7' },
        { value: '4.8', label: '4.8' },
        { value: '4.9', label: '4.9' },
        { value: '5.0', label: '5.0' },
        { value: '5.1', label: '5.1' },
        { value: '5.2', label: '5.2' },
        { value: '5.3', label: '5.3' }
      ],
      SubRule_RefractiveDiscrepancyUser_Add: false,
      SubRule_RefractiveDiscrepancyUser_Edit: false,
      SubRule_RefractiveDiscrepancyUser_FuCha: false
    }
  },
  mounted () {
    this.apiGetRefractiveDiscrepancyUserNum()
    this.apiGetRefractiveDiscrepancyUserList()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_RefractiveDiscrepancyUser_Add', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_RefractiveDiscrepancyUser_Add = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_RefractiveDiscrepancyUser_Edit', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_RefractiveDiscrepancyUser_Edit = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_RefractiveDiscrepancyUser_FuCha', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_RefractiveDiscrepancyUser_FuCha = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetRefractiveDiscrepancyUserList()
    },
    tabclick (e) {
      this.addCustomer.sn = ''
      this.addCustomer.phone = ''
      this.addCustomer.password = ''
      this.addCustomer.name = ''
      this.addCustomer.age = ''
      this.addCustomer.sex = '1'
      this.addCustomer.diopterstate = '0'
      this.addCustomer.righteyedegree = '0.00'
      this.addCustomer.rightcolumnmirror = '0.00'
      this.addCustomer.rightaxial = '0'
      this.addCustomer.lefteyedegree = '0.00'
      this.addCustomer.leftcolumnmirror = '0.00'
      this.addCustomer.leftaxial = '0'
      this.addCustomer.nakedrighteyedegree = '0'
      this.addCustomer.nakedlefteyedegree = '0'
      this.addCustomer.nakedbinoculusdegree = '0'
      this.addCustomer.correctrighteyedegree = '0'
      this.addCustomer.correctlefteyedegree = '0'
      this.addCustomer.correctbinoculusdegree = '0'
      this.addCustomer.interpupillary = ''
      this.addCustomer.addtype = '0'
      this.addCustomer.alod = '0.00'
      this.addCustomer.alos = '0.00'
      this.addCustomer.ampod = '0.00'
      this.addCustomer.ampos = '0.00'
      this.addCustomer.ampou = '0.00'
      this.addCustomer.nraod = '0.00'
      this.addCustomer.nraos = '0.00'
      this.addCustomer.nraou = '0.00'
      this.addCustomer.praod = '0.00'
      this.addCustomer.praos = '0.00'
      this.addCustomer.praou = '0.00'
      this.addCustomer.bcc = '0.00'
      this.addCustomer.flipperod = '0.00'
      this.addCustomer.flipperos = '0.00'
      this.addCustomer.flipperou = '0.00'
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetRefractiveDiscrepancyUserList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetRefractiveDiscrepancyUserNum()
      this.apiGetRefractiveDiscrepancyUserList()
    },
    clickAdd () {
      this.apiAddRefractiveDiscrepancyUser()
    },
    // 编辑用户
    goCustomerChange (row) {
      this.activeName = 'five'
      this.$refs.SubVuefive.LoadData(row)
    },
    // 视力复查
    goViewVisionReview (row) {
      this.activeName = 'seven'
      this.$refs.SubVueseven.LoadData(row)
    },
    apiGetRefractiveDiscrepancyUserList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        sn: that.keywords.sn,
        account: that.keywords.account,
        name: that.keywords.name,
        phone: that.keywords.phone,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRefractiveDiscrepancyUserList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetRefractiveDiscrepancyUserNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        sn: that.keywords.sn,
        account: that.keywords.account,
        name: that.keywords.name,
        phone: that.keywords.phone,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetRefractiveDiscrepancyUserNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddRefractiveDiscrepancyUser: function () {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        sn: that.addCustomer.sn,
        phone: that.addCustomer.phone,
        password: that.addCustomer.password,
        name: that.addCustomer.name,
        age: that.addCustomer.age,
        sex: that.addCustomer.sex,
        diopterstate: that.addCustomer.diopterstate,
        righteyedegree: that.addCustomer.righteyedegree,
        rightcolumnmirror: that.addCustomer.rightcolumnmirror,
        rightaxial: that.addCustomer.rightaxial,
        lefteyedegree: that.addCustomer.lefteyedegree,
        leftcolumnmirror: that.addCustomer.leftcolumnmirror,
        leftaxial: that.addCustomer.leftaxial,
        nakedrighteyedegree: that.addCustomer.nakedrighteyedegree,
        nakedlefteyedegree: that.addCustomer.nakedlefteyedegree,
        nakedbinoculusdegree: that.addCustomer.nakedbinoculusdegree,
        correctrighteyedegree: that.addCustomer.correctrighteyedegree,
        correctlefteyedegree: that.addCustomer.correctlefteyedegree,
        correctbinoculusdegree: that.addCustomer.correctbinoculusdegree,
        interpupillary: that.addCustomer.interpupillary,
        addtype: that.addCustomer.addtype,
        alod: that.addCustomer.alod,
        alos: that.addCustomer.alos,
        ampod: that.addCustomer.ampod,
        ampos: that.addCustomer.ampos,
        ampou: that.addCustomer.ampou,
        nraod: that.addCustomer.nraod,
        nraos: that.addCustomer.nraos,
        nraou: that.addCustomer.nraou,
        praod: that.addCustomer.praod,
        praos: that.addCustomer.praos,
        praou: that.addCustomer.praou,
        bcc: that.addCustomer.bcc,
        flipperod: that.addCustomer.flipperod,
        flipperos: that.addCustomer.flipperos,
        flipperou: that.addCustomer.flipperou
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddRefractiveDiscrepancyUser, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetRefractiveDiscrepancyUserNum()
            that.apiGetRefractiveDiscrepancyUserList()
          })
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
